import * as swcHelpers from '@swc/helpers';
import { unwrapResponse } from '../../response.js';
import { acceptJson, authHeader } from '../../shared.js';

const deleteAddress = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apiUrl, { customerId , accessToken , addressId  }) {
        return unwrapResponse((yield fetch(`${apiUrl}/customers/customers/${encodeURIComponent(customerId)}/addresses/${addressId}`, {
            method: 'DELETE',
            headers: swcHelpers.objectSpread({}, acceptJson, authHeader(accessToken))
        })));
    });
    return function deleteAddress(apiUrl, _) {
        return _ref.apply(this, arguments);
    };
}();

export { deleteAddress };
//# sourceMappingURL=delete.js.map
